<template>
  <div id="content">
    <router-link
        tag="button"
        class="btn-blue btn-resize"
        :to="'/operationV2/'+$route.params._id"><i class="fas fa-long-arrow-alt-left"></i></router-link>
    <!--Mode Test -->
    <div class="contenair homeop">
      <!-- Date fin : <input type="date" name="" id="" v-model="end"> -->
      <table v-if="variableFee" border="1px">
        <tr>
          <th>Facturé le</th>
          <th>Nombre</th>
          <th>Amount</th>
        </tr>
        <tr>
          <th colspan="3">Saisie</th>
        </tr>
        <tr v-for="line in variableFee.saisieCount">
          <td>{{displayInvoice(line._id)}}</td>
          <td>{{line.count}}</td>
          <td>Montant</td>
        </tr>
        <tr>
          <th colspan="3">Remises de virement</th>
        </tr>
        <tr v-for="line in variableFee.bankTransfertCount">
          <td>{{displayInvoice(line._id)}}</td>
          <td>{{line.count}}</td>
          <td>Montant</td>
        </tr>
        <tr>
          <th colspan="3">Expeditions</th>
        </tr>
        <tr v-for="line in variableFee.expeditionCount">
          <td>{{displayInvoice(line._id)}}</td>
          <td>{{line.count}}</td>
          <td>Montant</td>
        </tr>
      </table>
      <button type="button" @click="createInvoice">Facturer maintenant</button>
    </div>
  </div>
</template>

<script>
const moment = require("moment");

export default {
  data() {
    return {
      variableFee: undefined,
      end: "",
    }
  },
  computed: {

  },
  methods: {
    displayInvoice(id) {
      console.log(id);
      if(id == null) {
        return "à facturer"
      }
      const invoice = this.variableFee.variableFeeInvoices.find((i)=> i._id == id);
      if(!invoice) {
        "facture inconnue"
      }
      return moment(invoice.date).format("DD/MM/YYYY HH:mm")
    },
    async loadData() {
      try {
        const {data} = await this.$axios.get(`/api/v2/variable-fees/${this.$route.params._id}`);
        console.log("variableFee", data);
        this.variableFee = data;

      } catch (e) {
        console.log(e)
      }
    },
    async createInvoice() {
      try {
        await this.$axios.post(`/api/v2/variable-fees/invoice`, {
          operationId: this.$route.params._id,
          date: this.variableFee.end
        });
        this.loadData();
      }catch(err) {
        console.log(err);
      }
    },
  },
  mounted() {
    this.loadData()
  }
}
</script>

<style scoped>

</style>